import React from "react";
import { useApp } from "context";
import { IAppointment } from "interfaces";
import { CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import { Custom } from "components";
import { Constants, Helpers, Routes } from "utils";
import CircleIcon from "@mui/icons-material/Circle";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

type Props = {
  sx?: any;
  item: IAppointment;
  appointment?: IAppointment;
};

export const Weekday = (props: Props) => {
  const { t, locale, theme } = useApp();

  const subtitle = Helpers.interpolate(t.message.appointment.consult_clinic, {
    name: props.item.clinic.username,
  });

  const waitingTime = Helpers.interpolate(t.message.appointment.waiting_time, {
    value: props.appointment?.averageWaitingTime,
  });

  const queuePosition = Helpers.interpolate(
    t.message.appointment.queue_position,
    {
      value: props.appointment?.queuePosition,
    }
  );

  const has = props.appointment && props.appointment.checkInTime !== null;

  const checkInAvailable = (() => {
    const oneHour = 1000 * 60 * 60;
    const dateOneHour = Date.now() + oneHour;
    const dateOneHourAfter = dateOneHour - oneHour * 2;
    const currentTime = new Date(props.item.scheduledTime);
    return (
      currentTime < new Date(dateOneHour) &&
      currentTime > new Date(dateOneHourAfter)
    );
  })();

  const statusColor = has
    ? theme.color.status.success.color
    : theme.palette.font.color;

  return (
    <Custom.Card sx={props.sx}>
      <CardHeader
        sx={{ padding: 0 }}
        avatar={
          <CircleIcon sx={{ fontSize: theme.font.md, color: statusColor }} />
        }
        action={
          <IconButton
            href={Helpers.interpolateURL(Routes.patient.chat, {
              id: props.item.clinicId,
            })}
            sx={{ color: theme.palette.font.color }}
          >
            <QuestionAnswerIcon />
          </IconButton>
        }
        title={
          <Typography
            component="div"
            sx={{
              textAlign: "left",
              fontSize: theme.font.md,
              color: theme.palette.font.color,
            }}
          >
            {Helpers.toRelativeDate(
              props.item.scheduledTime,
              t.relative_date,
              locale
            )}
          </Typography>
        }
        subheader={
          <Typography
            component="div"
            sx={{
              fontSize: theme.font.sm,
              color: theme.palette.font.accent,
            }}
          >
            {subtitle}
          </Typography>
        }
      />
      <CardContent sx={{ px: 0, pt: theme.margin.md, pb: "0 !important" }}>
        {has ? (
          <Custom.Chip
            label={Helpers.interpolate(t.message.appointment.check_in_done, {
              time: new Date(
                props.appointment?.checkInTime ?? ""
              ).toLocaleTimeString(locale, Constants.TIME_FORMAT),
            })}
          />
        ) : checkInAvailable ? (
          <Custom.Chip label={t.message.appointment.check_in_pending} />
        ) : (
          <Custom.Chip label={t.message.appointment.check_in_unavailable} />
        )}
      </CardContent>
    </Custom.Card>
  );
};
